import { useMemo } from "react";
import {
  VideoPlayerGroupProvider,
  useVideoPlayerGroupContext,
} from "../contexts/VideoPlayerGroupContext";
import { VideoSource } from "./VideoSourceSelector";
import { MultiFeedVideoPlayer } from "./MultiFeedVideoPlayer";
import type { MultiFeedVideoPlayerProps } from "./MultiFeedVideoPlayer";

export const MultipleAnglesVideoPlayer = ({
  location,
  ...rest
}: {
  location: string;
} & MultiFeedVideoPlayerProps) => {
  return (
    <VideoPlayerGroupProvider location={location}>
      <InnerMultipleAnglesVideoPlayer {...rest} location={location} />
    </VideoPlayerGroupProvider>
  );
};

const InnerMultipleAnglesVideoPlayer = ({
  ...rest
}: {
  location: string;
} & MultiFeedVideoPlayerProps) => {
  const { currentAnglesForDisplay, isLoading } = useVideoPlayerGroupContext();

  const source: VideoSource = useMemo(
    () => ({
      mode: "angle_group" as const,
      videoPlayerGroups: currentAnglesForDisplay,
    }),
    [currentAnglesForDisplay]
  );

  return (
    <MultiFeedVideoPlayer source={source} isLoading={isLoading} {...rest} />
  );
};
